import { render, staticRenderFns } from "./I2FormDateRange.vue?vue&type=template&id=2b184ec5&"
import script from "./I2FormDateRange.vue?vue&type=script&lang=js&"
export * from "./I2FormDateRange.vue?vue&type=script&lang=js&"
import style0 from "./I2FormDateRange.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports